/* eslint-disable react/no-danger */
import { usePathname, useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "@audacia-hq/shared/components";

import { getContentFromServer } from "../../ssr/services/actions";
import Button from "../Button";
import CustomIcon from "../icons/CustomIcon";

const WelcomeOfferBanner: React.FC = () => {
  const { t } = useTranslation(["common", "home"]);
  const router = useRouter();

  const pathname = usePathname();
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const [terms, setTerms] = useState<string>();

  useEffect(() => {
    getContentFromServer("member", "welcomeOffer").then((d) => setTerms(d.data.content[0].content));
  }, []);

  return !pathname.startsWith("/login") ? (
    <>
      <Modal
        title={t("member:welcomeOffer.terms")}
        show={helpModalOpen}
        mobileFullscreen={false}
        onClose={() => setHelpModalOpen(false)}
      >
        <div dangerouslySetInnerHTML={{ __html: terms }} className="px-4" />
        <div className="flex justify-end">
          <div><Button render="transparent" onClick={() => setHelpModalOpen(false)}>{t("close")}</Button></div>
        </div>
      </Modal>
      <div
        className="lg:animate-gradient bg-gradient-to-r from-blue-700 via-violet-600 to-violet-600"
        data-pw="welcomeOfferBanner"
      >
        {!pathname.startsWith("/register") ? (
          <div className="wrapper">
            <div className="flex w-full xl:w-auto justify-center items-center gap-2 sm:gap-4 px-2 py-3 text-white text-xs sm:text-sm xl:text-lg">
              <CustomIcon icon="sparkle" />
              <div className="flex-wrap lg:flex gap-x-2 gap-y-1">
                <div className="font-medium">{t("promotion.welcomeOffer")}</div>
                <div>
                  <button type="button" className="underline hover:cursor-pointer whitespace-nowrap" onClick={() => setHelpModalOpen(true)}>{t("learnMore")}</button>
                </div>
              </div>
              <div><Button render="white" size="marketing" onClick={() => router.push("/register")}>{t("home:signup")}</Button></div>
            </div>
          </div>
        )
          : (
            <div className="wrapper">
              <div className="flex w-full xl:w-auto justify-center items-center gap-2 sm:gap-4 px-2 py-3 text-white text-xs sm:text-sm xl:text-lg">
                <CustomIcon icon="sparkle" className="text-white" />
                <div className="font-medium">{t("promotion.welcomeOfferShort")}</div>
                <CustomIcon icon="sparkle" />
              </div>
            </div>
          )}
      </div>
    </>
  ) : <></>;
};

export default WelcomeOfferBanner;
